<template>
  <v-container fluid class="contacts">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" sm="2">
            <h3>My Contacts</h3>
          </v-col>
          <v-col cols="12" md="9" sm="10" class="text-right">
            <v-btn
              class="mx-2 contacts--button"
              color="primary"
              :disabled="checkPersonal"
              :to="{ name: 'ContactForm', params: { type: 'Personal' } }"
            >
              <v-icon class="mx-2"> add </v-icon>
              personal
            </v-btn>
            <v-btn
              class="mx-2 contacts--button"
              color="primary"
              :to="{ name: 'ContactForm', params: { type: 'Work' } }"
            >
              <v-icon class="mx-2"> add </v-icon>
              work
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider />
    <v-card flat class="mt-3">
      <v-card v-for="(contact, i) in contacts" :key="i" class="mx-auto" flat>
        <v-card-title class="d-flex justify-space-between">
          <div>
            <p>{{ contact.type }} Contact</p>
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Phone Number"
                :value="contact.phoneNo"
                readonly
                prepend-inner-icon="phone"
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Email"
                :value="contact.eMail"
                readonly
                prepend-inner-icon="email"
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Address"
                :value="contact.address"
                readonly
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Physical Address"
                :value="contact.address2 || 'unknown'"
                readonly
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6" class="mt-n5">
              <v-text-field
                label="Country"
                :value="contact.countryCode || 'unknown'"
                readonly
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6" class="mt-n5">
              <v-text-field
                label="City"
                :value="contact.city || 'unknown'"
                readonly
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="6"
              v-if="contact.type !== 'Personal'"
              class="mt-n5"
            >
              <v-text-field
                label="Location"
                :value="contact.location || 'unknown'"
                readonly
                outlined
                persistent-placeholder
                dense
                filled
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="6"
              v-if="contact.type !== 'Personal'"
              class="mt-n5"
            >
              <v-text-field
                label="Designation"
                :value="contact.designation || 'unknown'"
                readonly
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="6"
              class="mt-n5"
              v-if="contact.type !== 'Personal'"
            >
              <v-text-field
                label="Place of Work"
                :value="contact.placeOfWork || 'unknown'"
                readonly
                outlined
                filled
                persistent-placeholder
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex">
            <v-btn
              class="contacts--button white--text mx-3"
              color="indigo"
              link
              :to="{
                name: 'ContactForm',
                param: { type: `${contact.type}` },
                query: { edit: `${contact.versionNo}` },
              }"
            >
              <v-icon class="mx-2"> edit </v-icon>
              Edit
            </v-btn>
            <v-spacer />
            <v-btn
              class="contacts--button"
              color="error"
              @click="deleteContact(contact)"
            >
              <v-icon class="mx-2"> delete </v-icon>
              Delete
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn
          class="mx-2 contacts--button"
          color="error"
          text
          @click="$router.back()"
        >
          <v-icon class="mx-2"> arrow_back </v-icon>
          Back
        </v-btn>
        <v-btn
          class="mx-2 contacts--button"
          outlined
          color="primary"
          :to="{ name: 'Academic' }"
        >
          Next
          <v-icon class="mx-2"> arrow_forward </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "ContactsComponent",
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.document.title = "KISEB::Contacts Profile";
    });
  },
  data: function () {
    return {};
  },
  computed: {
    contacts() {
      return this.$store.getters["Profile/contacts"].filter(
        (item) => item.status === "Active",
      );
    },
    checkPersonal() {
      return this.contacts
        ? this.contacts.filter((item) => item.type === "Personal").length !== 0
        : false;
    },
  },
  methods: {
    deleteContact(contact) {
      delete contact.studentprofiles;
      this.$store.dispatch("Profile/deleteContact", { ...contact });
    },
  },
};
</script>
<style>
@import url("./styles.css");
.v-text-field {
  margin: 0;
  padding: 0;
}
</style>
<style lang="scss">
.inputs-container {
  .col-12 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .theme--light.v-input {
    padding-top: 0;
  }

  .v-input__slot {
    margin-bottom: 0;
  }
}
</style>
